import { render, staticRenderFns } from "./AllReturnReasons.vue?vue&type=template&id=a8e12922&"
import script from "./AllReturnReasons.vue?vue&type=script&lang=js&"
export * from "./AllReturnReasons.vue?vue&type=script&lang=js&"
import style0 from "./AllReturnReasons.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports